// ABOUTME: Overlay component that shows when required parameters are missing
// ABOUTME: Used to block sections until prerequisite data is entered (e.g., body fat for metabolism)

import type { FC, ReactNode } from "react"

interface RequiredParamsOverlayProps {
  /** Whether to show the overlay */
  show: boolean
  /** Message to display explaining what's needed */
  message: string
  /** Optional icon to display above the message */
  icon?: ReactNode
  /** Children content that will be overlaid */
  children: ReactNode
  /** Additional class for the container */
  className?: string
  /** Offset from top to not cover the header (default: 40px) */
  topOffset?: string
}

export const RequiredParamsOverlay: FC<RequiredParamsOverlayProps> = ({
  show,
  message,
  icon,
  children,
  className = "",
  topOffset = "top-10",
}) => {
  return (
    <div className={`${show ? "relative" : ""} ${className}`}>
      {children}

      {show && (
        <div
          className={`absolute inset-0 ${topOffset} bg-white/80 backdrop-blur-[1px] rounded-xl flex items-center justify-center z-10`}
        >
          <div className="text-center px-4">
            {icon && <div className="mb-2 flex justify-center">{icon}</div>}
            <div className="text-gray-500 text-sm">{message}</div>
          </div>
        </div>
      )}
    </div>
  )
}
